import React, { useState } from "react";
import Image from "next/image";
import { buildTurfDetailRoute } from "../../utils/turfRoutes";

interface ShareButtonProps {
  className: string;
  city: string;
  turfUsername: string;
  pitchName: string;
  areaName?: string | null;
}

const ShareButton: React.FC<ShareButtonProps> = ({ className, city, turfUsername, pitchName, areaName }) => {
  const [isSharing, setIsSharing] = useState(false);
  
  // Construct the turf/court page URL
  const getShareLink = () => {
    const basePath = buildTurfDetailRoute({
      city,
      userName: turfUsername,
      pitchName,
      areaName,
    });
    
    if (typeof window !== 'undefined') {
      return `${window.location.origin}${basePath}`;
    }
    return basePath;
  };
  
  const shareLink = getShareLink();

  const handleShare = async (): Promise<void> => {
    if (isSharing) return; // Prevent multiple concurrent shares
    
    if (navigator.share) {
      try {
        setIsSharing(true);
        await navigator.share({
          title: "Share this Turf",
          url: shareLink,
        });
      } catch (error) {
        // Don't log AbortError - user just cancelled the share dialog
        if ((error as Error).name !== 'AbortError') {
          console.error("Error sharing:", error);
        }
      } finally {
        setIsSharing(false);
      }
    } else {
      navigator.clipboard.writeText(shareLink);
      alert('Link copied to clipboard!');
    }
  }

  return (
    <div onClick={handleShare} style={{ cursor: 'pointer', display: 'inline-block' }}>
      <Image className={className} src="/Icon/share-btn.svg" height={30} width={30} alt="Share" unoptimized />
    </div>
  );
};

export default ShareButton;